import { render, staticRenderFns } from "./PartnersConnections.vue?vue&type=template&id=b7e8a67e&"
import script from "./PartnersConnections.vue?vue&type=script&lang=ts&"
export * from "./PartnersConnections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports